import CircularLoading from '@/components/circular-loading';
import CheckCircle from '@mui/icons-material/CheckCircle';
import HelpOutlined from '@mui/icons-material/HelpOutlined';
import Warning from '@mui/icons-material/Warning';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';

import React from 'react';

type AddressVerificationStatusProps = {
  isLoading: boolean;
  isError: boolean;
  isDeliverable: boolean;
  onViewDetails: () => void;
};

const AddressVerificationStatus: React.FC<AddressVerificationStatusProps> = ({
  isLoading,
  isError,
  isDeliverable,
  onViewDetails
}) => {
  return (
    <Box ml={3.5} mt={1}>
      <Stack
        alignItems='center'
        direction='row'
        divider={<Divider flexItem orientation='vertical' />}
        spacing={1}>
        <Stack alignItems='center' direction='row' spacing={1}>
          {isLoading ? (
            <CircularLoading />
          ) : isError ? (
            <>
              <HelpOutlined color='disabled' fontSize='small' />
              <Typography variant='body2'>Unverified</Typography>
            </>
          ) : isDeliverable ? (
            <>
              <CheckCircle color='success' fontSize='small' />
              <Typography variant='body2'>Verified</Typography>
            </>
          ) : (
            <>
              <Warning color='warning' fontSize='small' />
              <Typography variant='body2'>May Not Reach</Typography>
            </>
          )}
        </Stack>
        <Button onClick={onViewDetails} size='small' variant='text'>
          {isError ? 'Verify Address' : 'View Details'}
        </Button>
      </Stack>
    </Box>
  );
};

export default AddressVerificationStatus;
